/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "headline_colors_default": "",
  "headline_variant_default": "",
  "headline_size_default": "text-al-headline-sm",
  "slide_caption_variant_default": "uppercase",
  "slide_caption_colors_default": "text-al-korall-600",
  "slide_caption_size_default": "text-al-category",
  "slide_description_colors_default": "",
  "slide_description_variant_default": "",
  "slide_description_size_default": "text-al-headline-xs sm:text-al-headline-sm",
  "slide_group_variant_default": "[counter-reset:most-read] flex-nowrap flex-row flex overflow-x-auto overflow-y-hidden scrollbar-thin snap-x !scrollbar",
  "slide_group_colors_default": "scrollbar-thumb-al-petroleum-300",
  "slide_group_size_default": "gap-3 pb-4 scrollbar-h-1.5",
  "slide_image_variant_default": "after:absolute after:bottom-0 after:content-[counter(most-read)] after:flex after:items-center after:justify-center after:right-1.5 after:rounded-full after:translate-y-1/2 relative [&_img]:rounded-sm",
  "slide_image_colors_primary": "after:bg-al-petroleum-600 after:text-white [&_picture]:bg-transparent [&_img]:bg-transparent",
  "slide_image_size_default": "w-61 sm:w-75 after:h-9 after:w-9 after:text-al-headline-sm mb-2",
  "slide_variant_default": "[counter-increment:most-read] flex-col flex grow relative snap-center",
  "slide_colors_default": "",
  "slide_size_default": "gap-1",
  "colors_default": "",
  "variant_default": "flex-col flex overflow-hidden",
  "size_default": "gap-2 sm:gap-3 py-6"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "MostRead");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;